import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import TournamentBase from '../../tournament-base';

@Component({
    selector: 'app-category-detail',
    templateUrl: './category-detail.component.html',
    styleUrls: ['./category-detail.component.scss'],
})
export class TournamentCategoryDetailComponent extends TournamentBase implements OnInit {
    departmentType: string = this.getDepartmentType();
    tournamentId: string = this.route.snapshot.paramMap.get('tournamentId');
    categoryId: string = this.route.snapshot.paramMap.get('categoryId');

    enrollments: any;
    tournament: any;
    category: any;
    games: any;
    classification: any;
    loading: boolean = false;

    constructor(protected route: ActivatedRoute) {
        super();
    }

    ngOnInit(): void {
        this.getTournament();
    }

    private getTournament() {
        this.loading = true;
        this.tournamentService.getTournamentByID(this.tournamentId, this.departmentType).subscribe((response) => {
            this.loading = false;
            this.tournament = response.registers;

            this.category = this.tournament.category.find((cat) => cat.id_categoria === this.categoryId);
        });
    }
}
